<template>
  <v-card>
    <v-card-text class="text-md-center">

      <v-flex xs12 sm6 md12>
        <v-select
          :items="plansList"
          v-model="itemData.plans_id"
          label="Select an existing plan"
        >
        </v-select>

        <v-flex md12 v-if="selectedPlan > 0">
<!--             <v-flex md12>
            <v-select
              :items="inventoriesList"
              multiple
              v-model="itemData.inventories"
              label="Select inventories"
            ></v-select>
          </v-flex> -->

          <v-flex md12>
            <v-select
              :items="servicesList"
              multiple
              v-model="itemData.services"
              label="Select services (replaces already added)"
            >
              <template slot="item" slot-scope="props">
                {{ props.item.name }} - {{ props.item.description }}
              </template>
              <template slot="selection" slot-scope="props">
                {{ props.item.name }} - {{ props.item.description }}
              </template>
            </v-select>
          </v-flex>
        </v-flex>

        <v-flex md12 v-if="!isInDialog && casesId > 0">
          <v-select
            :items="['Comfort S30', 'Comfort S803', 'Deluxe Lotus S809', 'S220', 'Teak']"
            v-model="itemData.casket_model"
            label="Select Casket Model"
          ></v-select>
        </v-flex>

<!--           <v-flex v-if="itemData.inventories && itemData.inventories.length > 0" class="text-md-left">
          <v-select
            :items="selectedInventoriesList"
            v-model="selectedInventoryForChecklist"
            label="Select inventory to edit checklist"
          ></v-select>

          <ItemCheckList v-if="selectedInventoryForChecklist > 0" :item-id="selectedInventoryForChecklist" :item-type="inventoryTypeID"></ItemCheckList>
        </v-flex> -->

        <v-flex v-if="itemData.services && itemData.services.length > 0 && this.enableChecklist" class="text-md-left">
          <v-select
            :items="selectedServicesList"
            v-model="selectedServiceForChecklist"
            label="Select service to edit checklist"
          ></v-select>

          <ItemCheckList v-if="selectedServiceForChecklist > 0" :cases-id="itemData.id" :item-id="selectedServiceForChecklist" :item-type="serviceTypeID"></ItemCheckList>
        </v-flex>
      </v-flex>

    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" flat @click.stop="editItemData(finalItemId)">Save</v-btn>
      <v-btn color="primary" flat @click.stop="$bus.$emit('dialog-close')" v-if="isInDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import casesAPI from '@/api/resources/cases'
  import plansAPI from '@/api/resources/plans'
  import clientsAPI from '@/api/resources/clients'
  import ItemCheckList from '@/components/ItemCheckList'
  import servicesAPI from '@/api/resources/services'

  export default {
    components: { ItemCheckList },
    mixins: [ dialogMixins, itemTypesMixins ],
    data () {
      return {
        resource: 'cases',
        enableChecklist: false,
        clientsList: [],
        inventoriesList: [],
        servicesList: [],
        plansList: [],
        selectedCasket: null,
        selectedInventoryForChecklist: null,
        selectedServiceForChecklist: null
      }
    },
    computed: {
      finalItemId () {
        return this.itemId > 0 ? this.itemId : this.casesId
      },
      selectedPlan: {
        get () {
          return this.itemData.plans_id
        },
        set (newVal) {
          this.itemData.plans_id = newVal
        }
      },
      selectedInventoriesList () {
        return this.inventoriesList.filter(item => this.itemData.inventories.includes(item.id))
      },
      selectedServicesList () {
        return this.servicesList.filter(item => this.itemData.services.includes(item.id))
      }
    },
    watch: {
      dialogModeCloseStatus (newVal) {
        if (newVal) {
          this.setEditItemIdZero()
        }
      },
      selectedPlan (newVal) {
        if (newVal > 0) {
          // inventoriesAPI.loadInventories().then(result => {
          //   this.inventoriesList = result
          //   this.itemData.inventories = []

          //   plansAPI.getLinkedInventories(newVal).then(result => {
          //     result.forEach(item => {
          //       this.itemData.inventories.push(item.id)
          //     })
          //   }, () => {})
          // })

          servicesAPI.loadServices().then(result => {
            this.servicesList = result
            this.itemData.services = []

            plansAPI.getLinkedServices(newVal).then(result => {
              result.forEach(item => {
                this.itemData.services.push(item.id)
              })
            }, () => {})
          })
        }
      }
    },
    methods: {
      afterEditCallback () {
        this.dialogResult = true

        this.selectedServicesList.forEach(item => {
          casesAPI.attachDefaultChecklistToCase(this.itemData.id, item.id)
        })

        this.enableChecklist = true
      }
    },
    mounted () {
      clientsAPI.loadClients().then(result => { this.clientsList = result }, () => {})
      plansAPI.loadPlans().then(result => { this.plansList = result }, () => {})

      if (!this.isInDialog && this.casesId > 0) {
        this.changedItemIdAction(this.casesId)

        casesAPI.getLinkedAnswers(this.finalItemId).then(result => {
          let casketModel = JSON.parse(result[0].answer).form_answers.find(item => item.input_id === 'casket_model')

          this.$set(this.itemData, 'casket_model', casketModel.answer)
        }, () => {})
      }
    },
    props: {
      isInDialog: {
        type: Boolean,
        default: false,
        required: false
      },
      casesId: {
        type: Number,
        default: 0,
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CasePlanAndServicesEdition.vue?489fb2cc